import type { Localized } from "@/i18n/types";

/** Group names are prose; the items are product names and stay as they are. */
export type SkillGroup = { name: Localized; items: readonly string[] };

export const skillGroups: readonly SkillGroup[] = [
  {
    name: { en: "Frontend", pt: "Frontend" },
    items: [
      "Next.js (SSR)",
      "React",
      "React Native",
      "TypeScript",
      "Redux / Redux Toolkit",
      "XState",
      "Tailwind",
      "styled-components",
      "SASS / LESS",
      "Electron",
      "Micro-frontends",
    ],
  },
  {
    name: { en: "Backend & Data", pt: "Backend e Dados" },
    items: [
      "Node.js",
      "NestJS",
      "Java",
      "Python",
      "GraphQL",
      "REST",
      "Loopback v4",
      "Serverless Framework",
      "PostgreSQL",
      "MySQL",
      "Oracle (PL/SQL)",
    ],
  },
  {
    name: { en: "Cloud & DevOps", pt: "Cloud e DevOps" },
    items: [
      "AWS (ECS, RDS, S3, Lambda, API Gateway, Route 53, CloudFront)",
      "Terraform",
      "Terragrunt",
      "Docker",
      "Kubernetes",
      "GitHub Actions",
      "Azure Pipelines",
      "Cloudflare",
    ],
  },
  {
    name: { en: "Messaging & Real-time", pt: "Mensageria e Tempo Real" },
    items: ["AWS EventBridge", "SQS", "SNS", "Google Pub/Sub", "Redis Queue", "Postgres Pub/Sub"],
  },
  {
    name: { en: "Testing", pt: "Testes" },
    items: ["Jest", "React Testing Library", "Cypress", "Playwright", "Karma", "Protractor"],
  },
  {
    name: { en: "Integrations", pt: "Integrações" },
    items: [
      "PayNearMe",
      "Venmo",
      "Trustly",
      "SeamlessChex",
      "GeoComply",
      "Firebase",
      "Customer.io",
      "Segment",
      "AppsFlyer",
      "Okta (SSO, OIDC, SAML)",
    ],
  },
  {
    name: { en: "ML & AI", pt: "ML e IA" },
    items: ["YOLO", "TrOCR", "AWS SageMaker", "Training", "Inference", "Prediction"],
  },
  {
    name: { en: "Familiar & legacy", pt: "Familiaridade e legado" },
    items: [
      "Angular / AngularJS",
      "jQuery",
      "PHP",
      "VBA / Excel",
      "Electron + DLL interop (Koffi)",
      "OCR",
    ],
  },
];
